'use client';
import cx from 'classnames';
import { v4 as uuid } from 'uuid';
import { CatSkeleton } from 'components/blocks-components';
import { ProductCardHeading } from '../product-card-heading';
import { Conditional, useBreakpoint } from 'components/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { ProductCardGridLoaderProps } from '../types';
import styles from './product-card-loader.module.scss';

const MobileImageLoader = () => (
  <div className="mb-2">
    <CatSkeleton size="lg" width="72px" />
    <CatSkeleton size="sm" width="72px" />
  </div>
);

export const ProductCardGridLoader = ({
  isHeaderLoader = true,
  title
}: ProductCardGridLoaderProps) => {
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  const isXL = useBreakpoint(PAGE_BREAKPOINTS.XL);

  const cardsPerRow = isXL ? 4 : 3;
  return (
    <>
      <Conditional test={isHeaderLoader}>
        <div className="d-flex justify-content-between mb-1">
          <ProductCardHeading title={title} />
          <CatSkeleton
            width="115px"
            className="px-0 py-1 mt-3 mt-blg-0 p-blg-3"
          />
        </div>
      </Conditional>
      <section className={styles['product-card-grid-loader-wrapper']}>
        {Array(cardsPerRow)
          .fill(0)
          .map(() => (
            <div key={uuid()} className={cx('card', styles['products-cards'])}>
              <Conditional test={isLG} fallback={<MobileImageLoader />}>
                <div className="mb-2">
                  <CatSkeleton size="lg" />
                  <CatSkeleton size="lg" />
                  <CatSkeleton />
                </div>
              </Conditional>

              <div className="w-100">
                <CatSkeleton className="d-block mb-2" size="sm" />
                <CatSkeleton size="sm" className="d-block mb-2 w-50" />
                <CatSkeleton className="d-block mb-2" />
                <CatSkeleton size="sm" />
              </div>
            </div>
          ))}
      </section>
    </>
  );
};
